export const confirmationModalTranslationsPl = {
    confirmationModalSubmit: 'Potwierdź',
    confirmationModalCancel: 'Anuluj',
};

export const confirmationModalTranslationsEn = {
    confirmationModalSubmit: 'Submit',
    confirmationModalCancel: 'Cancel',
};
